<template>
	<div class="paiming">
		<div class="nr">
			<div class="item" v-for="item in items" :key="item.id">
				<Button class="btn" :type="item.type">{{item.pm}}</Button>
				<div class="address">{{item.address}}</div>
				<div class="tx">
					<Progress :percent="item.bfb" style="width: 200px;"  hide-info />
				</div>
				<div class="sl">{{item.sl}}</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return {
			}
		},
		props:['items']
	}
</script>

<style scoped="scoped" lang="less">
	.paiming{
		border:1px solid #092537;
		min-width: 500px;
		min-height: 400px;
		height: 400px;
		padding: 5px;
		.bt{
			
		}
		.nr{
			display: flex;
			flex-direction: column;
			.item{
				display: flex;
				justify-content: space-between;
				align-items: center;
				margin-top: 20px;
				.btn{
					font-size: 12px;
				}
				.sl{
					margin-right: 10px;
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/comm/home/paiming.vue